export default function Footer() {
  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p className="text-muted-foreground">
            © {new Date().getFullYear()} SEMANDO INC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
